import React, { createContext, useContext, useState } from 'react';
import moment from 'moment';
import {
  EndPointReportDaily,
  EndPointReportIncident,
  EndPointReportStock,
  EndPointReportWarehouse,
  EndPointReportCollectionPoints
} from '../Services/EndPointReport';
import download from 'downloadjs';

export const ReportContext = createContext();

// Custom hook to use the Report context
export const useReport = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReport must be used within a ReportProvider');
  }
  return context;
};

// Provider component
export const ReportProvider = ({ children }) => {
  const [dailyStartDate, setDailyStartDate] = useState(moment());
  const [rangeStartDate, setRangeStartDate] = useState(moment());
  const [rangeEndDate, setRangeEndDate] = useState(moment());
  const [incidentStartDate, setIncidentStartDate] = useState(moment());
  const [incidentEndDate, setIncidentEndDate] = useState(moment());
  const [stockStartDate, setStockStartDate] = useState(moment());
  const [warehouseStartDate, setWarehouseStartDate] = useState(moment());
  const [warehouseEndDate, setWarehouseEndDate] = useState(moment());
  const [successMessage, setSuccessMessage] = useState(false);

  const handleDownloadReport = async (reportType, params = {}) => {
    try {
      let response;
      let filename;
      
      switch (reportType) {
        case 'daily':
          const dailyStart = dailyStartDate.format("YYYY-MM-DD");
          response = await EndPointReportDaily(dailyStart);
          filename = `Reporte-diario-${dailyStart}.xlsx`;
          break;
          
        case 'incidents':
          const dateI = incidentStartDate.format("YYYY-MM-DD");
          const dateF = incidentEndDate.format("YYYY-MM-DD");
          response = await EndPointReportIncident(dateI, dateF);
          filename = `Reporte-entre-${dateI}-${dateF}.xlsx`;
          break;
          
        case 'stock':
          const stockDateFormatted = stockStartDate.format("YYYY-MM-DD");
          response = await EndPointReportStock(stockDateFormatted);
          filename = `Reporte-stock-${stockDateFormatted}.xlsx`;
          break;
          
        case 'warehouse':
          const warehouseDateI = warehouseStartDate.format("YYYY-MM-DD");
          const warehouseDateF = warehouseEndDate.format("YYYY-MM-DD");
          response = await EndPointReportWarehouse(warehouseDateI, warehouseDateF);
          filename = `Reporte-patios-temporales-${warehouseDateI}-${warehouseDateF}.xlsx`;
          break;

        case 'collectionPoints':
          const collectionDateI = rangeStartDate.format("YYYY-MM-DD");
          const collectionDateF = rangeEndDate.format("YYYY-MM-DD");
          response = await EndPointReportCollectionPoints(collectionDateI, collectionDateF);
          filename = `Reporte-acumulado-puntos-acopio-${collectionDateI}-${collectionDateF}.xlsx`;
          break;

          
        default:
          throw new Error(`Unknown report type: ${reportType}`);
      }
      
      if (response.status >= 200 && response.status < 400) {
        const content = response.headers["content-type"];
        download(response.data, filename, content);
        setSuccessMessage(true);
        setTimeout(() => setSuccessMessage(false), 3000);
      } else {
        alert("No se pudo descargar el archivo");
      }
    } catch (error) {
      console.error(`Error downloading ${reportType} report:`, error);
      alert("No se pudo descargar el archivo");
    }
  };


  const contextValue = {
    dailyStartDate,
    rangeStartDate,
    rangeEndDate,
    incidentStartDate,
    incidentEndDate,
    stockStartDate,
    warehouseStartDate,
    warehouseEndDate,
    successMessage,
    setDailyStartDate,
    setRangeStartDate,
    setRangeEndDate,
    setIncidentStartDate,
    setIncidentEndDate,
    setStockStartDate,
    setWarehouseStartDate,
    setWarehouseEndDate,
    setSuccessMessage,
    handleDownloadReport,
  };

  return (
    <ReportContext.Provider value={contextValue}>
      {children}
    </ReportContext.Provider>
  );
};
